<template>
  <v-card height="90%">
    <v-card-title class="font-weight-bold text-h5 py-6">
      <span v-if="mode=='base'">自治体職員（管理者）</span><span v-if="mode=='lid'||mode=='addLid'">{{ $t('Lid') }}管理者</span><span v-if="mode=='pj'">{{$t('プロジェクト')}}管理者</span><span v-if="realCondition=='add'">の追加</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="realCondition='display',$emit('listAdmClose', false)">
        <v-icon x-large>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-container fluid>
      <v-row dense>
        <!--左側-->
        <v-col cols="4">
          <v-card elevation="0" class="text-center">
            <v-row class="pt-12">
              <div class="mx-auto"><v-img max-width="100" max-height="100" src="../assets/logo/logo.png"></v-img></div>
            </v-row>
            <v-row>
              <v-col>
                <p v-if="mode=='lid'"><span class="font-weight-bold" style="font-size:26px;" v-text="lidTitle" v-if="lidTitle"></span></p>
                <p v-else-if="mode=='base'"><span class="font-weight-bold" style="font-size:26px;" v-text="basetitle" v-if="basetitle"></span></p>
                <p v-else-if="mode=='pj'"><span class="font-weight-bold" style="font-size:26px;" v-text="aboutpj.title" v-if="aboutpj"></span></p>
                <v-card-text class="d-flex text-subtitle-1 px-6 py-2" v-if="mode!=='base'">
                  <span class="mr-auto abyss--text"><span v-if="mode=='lid'">{{ $t('Lid') }}管理者</span><span v-if="mode=='pj'">{{$t('プロジェクト')}}管理者</span></span>
                  <span v-if="mode!=='addLid'">{{usersNum}}人</span>
                </v-card-text>
                <v-card-text class="d-flex text-subtitle-1 px-6 py-2"><span class="mr-auto abyss--text">自治体職員（管理者）</span>{{baseAdmins.gov.length}}人</v-card-text>
                <v-card-text class="d-flex text-subtitle-1 px-6 py-2"><span class="mr-auto abyss--text">Liquitousスタッフ</span>{{baseAdmins.liq.length}}人</v-card-text>
              </v-col>
            </v-row>  
          </v-card>
        </v-col>
        <v-col cols="8">
          <v-text-field 
            class="mx-4 my-2" 
            v-model="keyword" 
            flat outlined dense hide-details
            placeholder="検索キーワードを入力" 
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
          <v-card
            height="50vh"
            color="#DCDCDC"
            elevation="0"
            class="px-4"
          >
            <v-divider></v-divider>
            <!--メンバー編集モード-->
            <v-list v-if="realCondition=='edit'" max-width="500" max-height="98%" class="overflow-y-auto">
              <v-list-item
                v-for="item in filteredUsers"
                :key="item"
                :input-value="onoff[item]"
                @click="onChange(item);"
                color="blue"
                style="height:50px;"
              >
                <v-avatar>
                  <v-img v-if="profImageDict[item]" max-width="40" max-height="40" :src="profImageDict[item]"/>
                  <v-icon v-else max-height="50" max-width="50" size="45" style="color:rgba(128,128,128,0.4)!important;">
                    mdi-account-circle
                  </v-icon>
                </v-avatar>
                <v-list-item-content v-if="sanka[item]=='管理者'">
                  <v-list-item-content v-if="item">
                    <v-list-item-title style="color:rgba(0,0,0,0.9) !important; font-family: mplus-2c !important; font-weight: 550 !important;" v-text="` ${namelist[item]}`"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title style="color:rgba(0,0,0,0.8) !important; font-family: mplus-2c;" v-text="` 未設定さん`"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item-content>
                <v-list-item-content v-if="sanka[item]=='非管理者'">
                  <v-list-item-content v-if="item">
                    <v-list-item-title style="color:rgba(0,0,0,0.5) !important; font-family: mplus-2c;" v-text="`${namelist[item]}`"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title style="color:rgba(0,0,0,0.5) !important; font-family: mplus-2c;" v-text="`未設定さん`"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item-content>
                <v-list-item-action v-if="baseAdmins">
                  <v-list-item-action-text class="pt-2" v-if="baseAdmins.liq.some((el) => el === item)">Liquitousスタッフ</v-list-item-action-text>
                  <v-list-item-action-text class="pt-2" v-else-if="baseAdmins.gov.some((el) => el === item)">自治体職員（管理者）</v-list-item-action-text>
                  <v-list-item-action-text class="pt-2" v-else-if="govstaffs.some((el) => el === item)">自治体職員</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-list-item-content v-if="!filteredUsers.length"><p class="text-center">まだ管理者はいません</p></v-list-item-content>
            </v-list>
            <!--表示onlyモード-->
            <v-list max-width="500" max-height="98%" class="overflow-y-auto" v-else-if="realCondition=='display'">
              <v-list-item
                v-for="item in filteredUsers"
                :key="item"
                color="blue"
                style="height:50px;"
                @click="profile=true,profileUid=item"
              >
                <v-avatar>
                  <v-img v-if="profImageDict[item]" max-width="40" max-height="40" :src="profImageDict[item]"/>
                  <v-icon v-else max-height="50" max-width="50" size="45" style="color:rgba(128,128,128,0.4)!important;">
                    mdi-account-circle
                  </v-icon>
                </v-avatar>
                <v-list-item-content v-if="sanka[item]=='管理者'">
                  <v-list-item-content v-if="item">
                    <v-list-item-title style="color:rgba(0,0,0,0.9) !important; font-family: mplus-2c !important; font-weight: 550 !important;" v-text="` ${namelist[item]}`"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title style="color:rgba(0,0,0,0.8) !important; font-family: mplus-2c;" v-text="` 未設定さん`"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item-content>
                <v-list-item-content v-if="sanka[item]=='非管理者'">
                  <v-list-item-content v-if="item">
                    <v-list-item-title style="color:rgba(0,0,0,0.5) !important; font-family: mplus-2c;" v-text="`${namelist[item]}`"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title style="color:rgba(0,0,0,0.5) !important; font-family: mplus-2c;" v-text="`未設定さん`"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item-content>
                <v-list-item-action v-if="baseAdmins">
                  <v-list-item-action-text class="pt-2" v-if="baseAdmins.liq.some((el) => el === item)">Liquitousスタッフ</v-list-item-action-text>
                  <v-list-item-action-text class="pt-2" v-else-if="baseAdmins.gov.some((el) => el === item)">自治体職員（管理者）</v-list-item-action-text>
                  <v-list-item-action-text class="pt-2" v-else-if="govstaffs.some((el) => el === item)">自治体職員</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <v-list-item-content v-if="filteredUsers.length==0"><p class="text-center mb-0">まだ管理者はいません</p></v-list-item-content>
            </v-list>
          </v-card>
          <v-card-actions>
            <!--<display>Lid/addLidモード:メンバーを編集-->
            <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="realCondition='edit'" v-if="(isAdmin&&realCondition=='display')&&(mode=='lid'||mode=='base'||mode=='pj')">メンバーを編集</v-btn>
            <!--<display>Lid/addLidモード:管理者招待リンク発行-->
            <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="generateInviteLink(),showAdminInviteLinkGenerationModal=true" v-if="(isAdmin&&realCondition=='display')&&(mode=='lid'||mode=='base')">管理者招待リンク発行</v-btn>
            <!--<edit>Lidモード:Lidメンバーを直接firestoreに登録-->
            <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="realCondition='display',submitLidAdmin()" v-if="(isAdmin&&realCondition=='edit')&&mode=='lid'">完了</v-btn>
            <!--<edit>addLidモード:Lidメンバーを確定、addLid.vueにデータを渡す(firestoreには登録せず)-->
            <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="$emit('lidCandiAdms', selectedMembers),$emit('listAdmClose', false)" v-else-if="(isAdmin&&realCondition=='edit')&&mode=='addLid'">完了</v-btn>
            <!--<edit>Baseモード:Baseメンバーを直接firestoreに登録-->
            <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="realCondition='display',submitBaseAdmin()" v-if="(isAdmin&&realCondition=='edit')&&mode=='base'">完了</v-btn>
            <!--<edit>Pjモード:Pjメンバーを直接firestoreに登録-->
            <v-btn color="#399942" dark class="mx-auto px-12" rounded @click="realCondition='display',submitPjAdmin()" v-if="(isAdmin&&realCondition=='edit')&&mode=='pj'">完了</v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
      <!-- showAdminInviteLinkGenerationModal -->
      <v-dialog v-if="showAdminInviteLinkGenerationModal" v-model="showAdminInviteLinkGenerationModal" max-width="500px">
        <v-card>
          <v-card-title class="headline">管理者招待リンク発行</v-card-title>
          <v-card-text>
            <p>
              ログインした上で以下のリンクを開くと、管理者権限を取得できます。
              <br/>
              リンクは今から72時間有効です。
            </p>
          </v-card-text>
          <!-- adminInviteLinkが空の場合progress-linerを出す -->
          <v-card-text v-if="inviteLink" @click="handleCopy">
            <v-text-field v-model="inviteLink" label="管理者招待リンク（クリックしてコピーできます）" readonly append-icon="mdi-clipboard-outline"></v-text-field>
          </v-card-text>
          <v-card-text v-else>
            <p>発行中...</p>
            <v-progress-linear indeterminate color="blue"></v-progress-linear>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="showAdminInviteLinkGenerationModal = false,inviteLink=''">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!--プロフィール画面-->
    <profile_display
      :profile="profile"
      :profuid="profileUid"
      :device="$mq"
      @closeProfile="profile = false"
    ></profile_display>
  </v-card>
</template>
  
<script>
  import Vue from 'vue'
  import Toasted from "vue-toasted";
  Vue.use(Toasted,{iconPack : 'material'})
  import firebase from 'firebase'
  const profile_display = () => import('./profile/profile_display.vue')
  import VueMq from 'vue-mq'
  Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
      sp: 959,
      pc: 960
    },
    defaultBreakpoint: 'pc' // customize this for SSR
  })
  export default {
      props:{
        lidId: String,
        lidTitle: String,
        //pjId: String,
        mode: String, //lid,addLid,base
      },
      components:{
        profile_display
      },
      data: () => ({
        db: null,
        candiMembers: [], //管理者候補ユーザーの元のデータ（メンバー編集時に参加済と未参加の区別に用いる）array
        selectedMembers: [], //管理者予定ユーザーを編集するデータ（メンバー編集時に参加済と未参加の区別に用いる）array
        keyword: '',
        onoff:{},
        sanka:{},
        realCondition: "display",
        isStart: false,
        pjId: "",
        usersNum:0, //メンバー数表示
        profile: false,
        profileUid: "",
        showAdminInviteLinkGenerationModal: false,
        inviteLink: "",
      }),
      created(){
        //初期設定：(Lidモードの場合)Lidメンバー情報取得、ベースメンバー情報取得、candiMembers_copy初期化
        this.db = firebase.firestore()
        this.isStart = true
        this.selectedMembers = []

        if(this.mode=="addLid") this.realCondition = "edit"
        if(this.mode=="base"||this.mode=="addLid"){
          let candimem = this.baseMembers.filter(el => el.isActive === true)
          candimem.forEach((el) => {
            this.candiMembers.push(el.uid)
          })
          if(this.mode=="base") this.selectedMembers = this.baseAdmins.gov
          this.updatemem()
        }
        if(this.mode=="lid"){
          this.$store.dispatch('getLidMembers',this.lidId)
        }
        if(this.mode=="pj") this.updatepj()
        //console.log("---------------------------",this.candiMembers,this.onoff,this.sanka);
      },
      methods: {
        showToast(message="完了しました"){
          this.$toasted.success(message, {
            theme: "bubble", 
            position: "top-center", 
            duration : 5000,
          });
        },
        async generateInviteLink() {
          try {
            console.log('generateInviteLink')
            // firebase functionsを叩いて、その結果を返す
            const generateInviteLink = firebase.functions().httpsCallable('generateInviteLink')
            const result = await generateInviteLink({
              lidId: this.lidId || undefined,
              asAdmin: true
            })
            this.inviteLink = result.data.inviteLink
          } catch (error) {
            console.error(`招待リンク発行失敗：${error}`)
            alert('管理者招待リンクの発行に失敗しました。この事象は開発チームに通知され、調査されます。時間をおいて再度お試しください。')
            this.showAdminInviteLinkGenerationModal = false
          }
        },
        handleCopy() {
          navigator.clipboard.writeText(this.inviteLink)
          this.showToast("招待リンクをコピーしました")
        },
        updatemem(){
          //全候補メンバー分のonoff/sanka初期化
          for(var i in this.candiMembers) {
            this.onoff[this.candiMembers[i]]=false
            this.sanka[this.candiMembers[i]]="非管理者"
          }
          
          //console.log("this.updatemem",this.candiMembers);
          //参加予定ユーザー全員(selectedMembers)にonoff/sankaの参加タグをつける
          for(let i in this.selectedMembers) {
            //if(this.candiMembers[i].name) 
            this.onoff[this.selectedMembers[i]]=true;
            //else this.onoff[this.selectedMembers[i]]=false;
            //if(this.candiMembers[i].name) 
            this.sanka[this.selectedMembers[i]]="管理者";
            //else this.sanka[this.selectedMembers[i]]="非管理者";
            //console.log("this.onoff",this.selectedMembers[i],this.onoff[this.selectedMembers[i]],this.sanka[this.selectedMembers[i]]);
          }
          //console.log("this.updatemem",this.onoff,this.sanka,this.candiMembers,this.selectedMembers);
        },
        onChange(id) {
          //on/off(管理者/非管理者)を切り替える
          //console.log("----旧----",this.onoff[id],this.sanka[id],this.selectedMembers);
          this.onoff[id] = !this.onoff[id];
          
          //参加状態タグを切り替える
          let newSanka=""
          if (this.sanka[id]=="管理者") newSanka="非管理者";
          if (this.sanka[id]=="非管理者") newSanka="管理者";
          this.sanka[id] = newSanka;
          
          //メンバー(selectedMembers)を全員登録しなおす
          let newMem=[]
          for(let i in this.candiMembers) {
            if(this.onoff[this.candiMembers[i]]==true){
              newMem.push(this.candiMembers[i])
              //console.log(i,newMem,this.onoff[this.candiMembers[i]],this.sanka[this.candiMembers[i]])
            }
          }
          this.selectedMembers = newMem;
          //console.log("----新----",this.onoff[id],this.sanka[id],this.selectedMembers);
        },
        ToSanka(k) {
          this.sanka[this.selectedMembers[k]]="管理者";
        },
        ToHusanka(k) {
          this.sanka[this.selectedMembers[k]]="非管理者";
        },
        memFilter(k) {
          this.selectedMembers = this.selectedMembers.filter(f=> this.selectedMembers[f] !== this.selectedMembers[k]);
          //console.log("filter",this.selectedMembers[k],this.selectedMembers)
        },
        count(nn){
          this.usersNum = nn
        },
        submitLidAdmin(){
          let self = this
          // //console.log("管理者登録")
          //console.log("--------",this.candiMembers,this.selectedMembers)
          if(this.selectedMembers.length>0){
            this.db.collection("0").doc(self.lidId).set({
              lidAdmin: self.selectedMembers,
              updatedAt: firebase.firestore.Timestamp.now()
            },{merge:true}).then(function(docRef) {
              // 保存に成功した時
              //console.log("ユーザー登録完了",self.selectedMembers)
              let index = self.lid?.findIndex(el => el.id == self.lidId)
              // -1はLidがない場合なので、非公開Lidから探す
              if (index!=-1) {
                self.lid[index].lidAdmin = self.selectedMembers
                self.$store.dispatch('setLidAdmin',{index:index, lidAdmin:self.selectedMembers})
              } else {
                index = self.alid.findIndex(el => el.id == self.lidId)
                self.$store.dispatch('setALidAdmin',{index:index, lidAdmin:self.selectedMembers})
              }
              self.selectedMembers.forEach((el) => {
                self.$store.dispatch('setConfigNotify',({title:`${self.$t('Lid')}管理者`,content:`${self.$t('Lid')}:${self.lidTitle}の管理者に追加されました。`,address:el,type:5,lidid:self.lidId,tag:"Lid"}))
              })
            }).catch(function(error) {
              // 保存に失敗した時
              console.error("ユーザー登録失敗: ", error)
              alert("Error!:"+error)
            })               
          }
        },
        submitPjAdmin(){
          let self = this
          //console.log("PJ管理者登録--------",this.candiMembers,this.selectedMembers)
          this.db.collection("0").doc(self.lidId).collection("project").doc(self.aboutpj.uid).set({
            pjAdmin: self.selectedMembers,
            updatedAt: firebase.firestore.Timestamp.now()
          },{merge:true}).then(function(docRef) {
            // 保存に成功した時
            //console.log("ユーザー登録完了",self.selectedMembers)
            self.$store.dispatch('setPjAdmin',self.selectedMembers)
            self.selectedMembers.forEach((el) => {
              self.$store.dispatch('setConfigNotify',({title:`${self.$t('プロジェクト')}管理者`,content:`${self.$t('プロジェクト')}:${self.aboutpj.title}の管理者に追加されました。`,address:el,type:15,lidid:self.lidId,tag:self.$t('プロジェクト')}))
            })
          }).catch(function(error) {
            // 保存に失敗した時
            console.error("ユーザー登録失敗: ", error)
            alert("Error!:"+error)
          })               
        },
        submitBaseAdmin(){
          let self = this
          // //console.log("管理者登録")
          //console.log("--------",this.candiMembers,this.selectedMembers)
          if(this.selectedMembers.length>0){
            this.db.collection("0").doc("config").collection("admins").doc("gov").set({
              admins: self.selectedMembers
            },{merge:true}).then(function(docRef) {
              // 保存に成功した時
              //console.log("ベースユーザー登録完了",self.selectedMembers)
              self.$store.dispatch('setBaseAdmin',self.selectedMembers)
            }).catch(function(error) {
              // 保存に失敗した時
              console.error("ベースユーザー登録失敗: ", error)
              alert("Error!:"+error)
            })
          }
        },
        updatepj(){
          if (this.mode=="pj"){
            this.selectedMembers = []
            this.candiMembers = []
            //console.log("pjadmins変更",this.aboutpj,this.aboutpj.pjAdmin,this.pjusers)
            if(this.aboutpj.pjAdmin) {
              this.selectedMembers = this.aboutpj.pjAdmin
            }
            //console.log("pjusers変更")
            if(this.pjusers) {
              //let candimem = this.pjusers.filter(el => el.isActive === true)
              this.pjusers.forEach((el) => {
                this.candiMembers.push(el.uid)
              })
            }
            this.updatemem()
          }
        },
        setPjId(){
          this.pjId = this.$store.state.aboutpj.uid
        }
      },
      computed: {
        //リスト表示用（検索対応版）
        filteredUsers() {
          // 表示用変数初期化
          var searchedUsers = [];
          //console.log("start",this.candiMembers,this.selectedMembers)
          //参加予定ユーザーを全員検査し、
          for(var k in this.selectedMembers) {
            //console.log("filteruserk",this.onoff[this.selectedMembers[k]])
            //onoffがoffになっているユーザーをcandiMembers_copyから排除し、不参加タグを付与する.
            if (this.onoff[this.selectedMembers[k]]==false){
              this.memFilter(k)
              this.ToHusanka(k)
              //this.selectedMembers = this.selectedMembers.filter(f=> f !== this.selectedMembers[k]); //computed内では変数を直接変更できないためいったん関数に置き換える
            }
            //onoffがonになっているユーザーには改めて参加状態タグをつける.
            if (this.onoff[this.selectedMembers[k]]==true) this.ToSanka(k)
            //console.log(this.selectedMembers[k],this.selectedMembers)
          }
          //console.log(this.selectedMembers);
          //console.log(this.sanka);
          
          // リスト表示用に出力
          if(this.realCondition == "edit"){
            //console.log("edit",this.candiMembers,this.selectedMembers)
            for(var i in this.candiMembers) {
              // //console.log(this.selectedMembers);
              // //console.log(this.candiMembers[i]);
              // //console.log(this.namelist[this.candiMembers[i]]);
              // //console.log("--------",this.onoff);
  
              // 検索用の準備
              let userName = "";
              if (this.namelist[this.candiMembers[i]] == null){
                userName = "";
              }else{
                userName = this.namelist[this.candiMembers[i]];
              }
              // //console.log(userName);
              //検索キーワードがある場合はそれにそれが含まれているものを抽出、ない場合は全て
              if(userName.indexOf(this.keyword) !== -1) {
                searchedUsers.push(this.candiMembers[i]);
              }
            }          
          }
          else if(this.realCondition == "display"){
            //console.log("display",this.candiMembers,this.selectedMembers)
            var nn = 0
            for(var j in this.selectedMembers) {
              // //console.log(this.candiMembers[j])
              nn++
              // //console.log(this.selectedMembers);
              //console.log("--------",this.onoff);
  
              // 検索用の準備
              let userName = "";
              if (this.namelist[this.selectedMembers[j]] == null){
                userName = "";
              }else{
                userName = this.namelist[this.selectedMembers[j]];
              }
              // //console.log(userName);
              if(userName.indexOf(this.keyword) !== -1) {
                searchedUsers.push(this.selectedMembers[j]);
              }
            }
            // 人数出力
            this.count(nn)
          }
          //管理者でmemにないユーザーをmemに代入する （管理者は無条件でmemに入れるため）
          /* 
          for(var j in this.baseMembers) {
            if (this.baseAdmins.gov.includes(this.baseMembers[j])==true && this.selectedMembers.includes(this.baseMembers[j])==false){
              this.selectedMembers.push(this.baseMembers[j]);
            }
          }*/
          return searchedUsers;
        },
        lid(){
          return this.$store.state.lid
        },
        alid(){
          return this.$store.state.alid
        },
        baseAdmins(){
          return this.$store.state.admins
        },
        govstaffs() {
          return this.$store.state.govstaffs;
        },
        baseMembers(){
          return this.$store.state.members
        },
        basetitle(){
          return this.$store.state.basetitle
        },
        lidusers(){
          return this.$store.state.lidusers
        },
        namelist(){
          return this.$store.state.namelist
        },
        profImageDict(){
          return this.$store.state.profImageDict
        },
        isAdmin(){
          return this.$store.state.isAdmin
        },
        aboutpj(el){
          //console.log("aboutpj",el)
          this.setPjId()
          return this.$store.state.aboutpj
        },
        pjusers(){
          return this.$store.state.pjusers
        },
      },
      watch:{
        lidId:{
          handler: function(v,ov) {
            //console.log("lidid変更検知",ov,v)
            if(this.mode=="lid"&&(v != ov)&&this.isStart&&v.length>1) {
              this.$store.dispatch('getLidMembers',v)
            }
          }
        },
        /* 
        candiMembers:{
          handler: function(v,ov) {
            //console.log("candiMembers変更検知",ov,v)
            //if(v.length>0&&ov!==v&&this.mode!=="addLid") this.updatemem()
          }
        },
        */
        pjId: {
          handler: function(v,ov) {
            //console.log("pjid変更検知",ov,v)
            if(this.mode=="pj"&&(v != ov)&&v.length>1) {
              this.updatepj()
            }
          }
        },
        lidusers:{
          handler: function(v,ov) {
            if(v.length>0&&ov!==v&&(this.mode=="lid")) {
              //console.log("lidusers変更",ov,v)
              this.candiMembers=[]
              this.selectedMembers=[]
              let candimem = this.lidusers.filter(el => el.isActive === true)
              candimem.forEach((el) => {
                this.candiMembers.push(el.uid)
              })
              if(this.lid){
                let index = this.lid.findIndex(el => el.id == this.lidId)
                //console.log(this.lid,this.lidId,index,this.lid[index])
                if (index !=-1)this.selectedMembers = this.lid[index].lidAdmin
              }
              if(this.alid){
                let index = this.alid.findIndex(el => el.id == this.lidId)
                //console.log(this.lid,this.lidId,index,this.lid[index])
                if (index !=-1) this.selectedMembers = this.alid[index].lidAdmin
              }
              this.updatemem()
            }
          }
        },
      }, 
  }
  </script>
  <style scoped>
  .close{
    position: fixed;
    right: 1%;
    top: 1%;
    width: 4%;
  }
  .v-checkbox:active {
      background-color: red !important;
  }
  .deepAlgae{
    color: #399942;
  }
  </style>